import { HideImage, Image, Map } from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { useBooleanFlagValue } from '@openfeature/react-sdk'
import { observer } from 'mobx-react-lite'
import { useGeoAnchor } from '../../hooks/use-geo-anchor'
import { BackgroundMode, YardViewStore } from '../../stores/yard.view-store'

interface Props {
  yardViewStore: YardViewStore
}

export const BackgroundModeSelector = observer(({ yardViewStore }: Props) => {
  const { t } = useTranslate()
  const geoAnchor = useGeoAnchor()
  const osmMapEnabled = useBooleanFlagValue('yard-osm-map', false)

  const handleChange = (_: React.MouseEvent, value: BackgroundMode | null) => {
    if (value !== null) {
      yardViewStore.setBackgroundMode(value)
    }
  }

  return (
    <ToggleButtonGroup
      exclusive
      value={yardViewStore.backgroundMode}
      onChange={handleChange}
      size='small'
    >
      {osmMapEnabled && (
        <ToggleButton value='map' disabled={!geoAnchor}>
          <Tooltip title={t('backgroundModeMap', 'Map')}>
            <Map fontSize='small' />
          </Tooltip>
        </ToggleButton>
      )}
      <ToggleButton value='image'>
        <Tooltip title={t('backgroundModeImage', 'Image')}>
          <Image fontSize='small' />
        </Tooltip>
      </ToggleButton>
      <ToggleButton value='none'>
        <Tooltip title={t('backgroundModeNone', 'None')}>
          <HideImage fontSize='small' />
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  )
})
